import Component from '../abstracts/Component';
import queryString from 'query-string';
import Observer from '../utils/ObserverIntersection';

export default class InfiniteScrollLogic extends Component {
  get SELECTORS() {
    return {
      main: '[data-infinite-scroll]',
      trigger: '[data-infinite-scroll-trigger]',
      label: '[data-infinite-scroll-label]'
    }
  }

  constructor() {
    super();
    this.viewMoreBtn = document.querySelector(this.SELECTORS.main);
    if(this.viewMoreBtn) {
      this.nextPage = document.querySelector(this.SELECTORS.main).dataset.page;
      this.label = this.viewMoreBtn.querySelector(this.SELECTORS.label);
    }
    const searchObj = queryString.parse(location.search);
    const preload = searchObj.preload;
    const page = parseInt(searchObj.page);
    this.wasPreloaded = preload || page > 0 || false;
    this.startPage = this.wasPreloaded ? page + 1 : 1;
    this.isBound = false;
  }

  // observer function
  observeScroll() {
    console.log('observer scroll');
    this.internalObserveScroll();
  }

  // setting observer
  internalObserveScroll() {
    this.scrollObserver = new Observer(this.SELECTORS.trigger, 0, null, (entries, observer) => {
      entries.forEach(entry => {
        if(entry.intersectionRatio > 0) {
          let nextPage = this.viewMoreBtn.dataset.page;
          let lastPage = this.viewMoreBtn.dataset.infiniteScrollLastpage;
          // if next page is minor than last
          if(parseFloat(nextPage) <= parseFloat(lastPage)) {
            if(parseFloat(nextPage) == parseFloat(lastPage)){
              this.viewMoreBtn.classList.add('hidden');
            }
            this.$emit(this.$customEvents.INFINITE_SCROLL_EVENTS.next, {page: nextPage});
          }
          observer.unobserve(entry.target);
        }
      });
    });
  }

  bindClickOnce() {
    this.isBound = true;
    // bind one click to trigger button
    this.$one('click.is', ({event}) => {
      event.stopPropagation();
      event.preventDefault();
      // hide it
      event.currentTarget.classList.add('hidden');
      // start infinite scroll events
      this.$emit(this.$customEvents.INFINITE_SCROLL_EVENTS.next, {page: this.startPage});
      this.isBound = false;
    }, this.SELECTORS.main);
  }

  bindEvents() {
    this.bindClickOnce();
    // i need to launch observer after the first click
    this.$on(this.$customEvents.INFINITE_SCROLL_EVENTS.loaded, ({event, payload}) => {
      let lastPage = this.viewMoreBtn.dataset.infiniteScrollLastpage;
      let nextPage = this.viewMoreBtn.dataset.page;
      // if next page is minor than last
      if(parseFloat(nextPage) < parseFloat(lastPage)) {
        // launch observer
        this.observeScroll();
      }
    });

    //resets button in case of new search query
    this.$on(this.$customEvents.FILTERS_EVENTS.updated, ({event, payload}) => {
      let newButton = payload.response.querySelector(this.SELECTORS.main);
      // check
      if (newButton != null) {
        this.viewMoreBtn.classList.remove('hidden');
        this.viewMoreBtn.dataset.page = this.nextPage;
        this.viewMoreBtn.dataset.infiniteScrollLastpage = newButton.getAttribute('data-infinite-scroll-lastpage');
        if (this.label) {
          this.label.innerHTML = newButton.querySelector(this.SELECTORS.label).innerHTML;
        }
      }
      // avoids multiple events on btn click
      if(this.isBound == false) {
        this.bindClickOnce();
      }
    });
  }

  render() {
    this.log('Load logics...');
    // if i find the main i start the events
    if(this.viewMoreBtn) this.bindEvents();
  }
}
